import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Wrapper = styled.div``;

export const ItemWrapper = styled.div`
  padding: 25px 20px;

  ${mediaQuery(540)} {
    padding: 25px 10px;
  }
`;

export const Item = styled.div`
  max-width: 700px;
  margin: auto;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 25px 30px;
  padding-right: 220px;

  height: 300px;
  overflow: hidden;
  text-align: left;
  ${responsiveFontSize(18, 1)}

  ${mediaQuery('medium')} {
    padding-right: 190px;
  }
  ${mediaQuery(540)} {
    padding: 25px;
  }
`;

export const ItemBackgroundImage = styled.div`
  border-top-left-radius: 55%;
  border-bottom-left-radius: 55%;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: -40px;
  bottom: -40px;

  width: 180px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${mediaQuery('medium')} {
    width: 150px;
  }
  ${mediaQuery(540)} {
    display: none;
  }
`;

export const ItemName = styled.div`
  font-weight: bold;
  color: ${(props) => props.theme.color.blue.default};
  margin-bottom: 10px;
`;

export const ItemText = styled.div`
  font-size: 14px;
  display: -webkit-box;
  display: -moz-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 0;
  line-height: 22px;
  max-height: ${9 * 22}px; ;
`;
